// Importing necessary libraries, action types, and helper functions
import * as types from "./ActionTypes"; // Importing action type constants
import { get } from "../Helper/fetch"; // Helper function for making GET requests
import * as urls from "../../modules/payout/api_interceptor/urls"; // Importing API endpoint URLs

// Action to fetch the last calculation date for payouts
export const lastCalculationDate = () => dispatch => {
  // Dispatch an action to indicate the API call has started
  dispatch({ type: types.GET_PAYOUT_LASTCALCDATE_CALL });

  // Make a GET request to fetch the last calculation date
  get({
    url: urls.GET_LAST_CALC_DATE, // API endpoint for fetching the last calculation date
    success: types.GET_PAYOUT_LASTCALCDATE_SUCCESS, // Action type for a successful response
    failure: types.GET_PAYOUT_LASTCALCDATE_ERROR, // Action type for a failed response
    dispatch, // Dispatch function to send actions to the Redux store
    body: false, // No request body is required for this API call
  });
};
